import { render, staticRenderFns } from "./PassengerFlowStatistics.vue?vue&type=template&id=2a5f0442&scoped=true&"
import script from "./PassengerFlowStatistics.vue?vue&type=script&lang=js&"
export * from "./PassengerFlowStatistics.vue?vue&type=script&lang=js&"
import style0 from "./PassengerFlowStatistics.vue?vue&type=style&index=0&id=2a5f0442&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5f0442",
  null
  
)

export default component.exports